import type React from 'react';
import { type FC, type PropsWithChildren, useMemo } from 'react';

import { ScError, ScFieldStructure } from './styled';

export interface FieldStructureProps extends PropsWithChildren {
  error?: React.ReactNode;
  disabled?: boolean;
  hideErrorMessage?: boolean;
}

export const FieldStructure: FC<FieldStructureProps> = ({
  error,
  hideErrorMessage = false,
  children,
  ...props
}) => {
  const isError = useMemo(
    () => !hideErrorMessage && !!error,
    [error, hideErrorMessage]
  );

  return (
    <ScFieldStructure {...props}>
      <div className="field-container">{children}</div>
      {isError && <ScError>{error}</ScError>}
    </ScFieldStructure>
  );
};
